import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import {
    MDBBtn,
    MDBInput,
    MDBSelect,
    MDBDatatable,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsContent,
    MDBTabsPane,
} from "mdb-react-ui-kit";
import { getAccountLevelBlfGroups } from '../../../apiclients/streamsapi_bridge';


function AddBlfGroups(props) {
    const [existedgroupname, setExistedgroupname] = useState(false);
    const [groupNameEmty, setGroupNameEmty] = useState(false);

    console.log("AddBlfGroups :: " + JSON.stringify(props));
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [groupname, setGroupname] = useState("");

    const saveGroupname = (e) => {
        console.log("accountBlfGroups :::: " + JSON.stringify(props.accountBlfGroups));
        var groupnames = [];
        props.accountBlfGroups.forEach(groups => {
            groupnames.push(groups.group_name);
        });
        if(e.target.value.trim() == ""){
            setGroupNameEmty("Group Name should not be empty")
        }else{
            setGroupNameEmty("");
        var exist = groupnames.includes(e.target.value);
        }
        setExistedgroupname(exist);
        if (exist) {
            return;
        }
        if (e && e.target) {
            setGroupname(e.target.value);
        }
    }

    const saveBlfGroup = async () => {
        if(groupname == ""){
        setGroupNameEmty("Group Name should not be empty");
        }
        props.onsave(groupname)
    }
    return (
        <>
            <strong>
                {t("BLFGroupName")}
            </strong>
            <div className="form mt-1 mb-2">
                <input type="text" className="form-control" onChange={saveGroupname} 
                placeholder="Please Enter BLF Group Name"
                maxLength={30}
                onKeyPress={(event) => {
                    if (!/[a-zA-Z0-9 _]/.test(event.key)) {
                        event.preventDefault();
                    }
                }}
                />
            </div>
            {existedgroupname && (
                <span className="red mb-1">The BLF Group Name entered already exists, please try a different name.</span>
            )}
            {!groupNameEmty == "" && (
                <span className="red mb-1">{groupNameEmty}</span>
            )}
            

            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
         {/* props.onsave(groupname) */}
                <MDBBtn disabled={existedgroupname} onClick={saveBlfGroup}>{t("add")}</MDBBtn>
            </MDBModalFooter>

        </>
    )
}

export default AddBlfGroups;